export default __webpack_public_path__ + "static/media/mike.67db90fb.jpeg";